import { cn } from '../lib/utils';
import { formatRelativeDate, formatDateWithTooltip } from '../utils/dateUtils';

/**
 * CheckTimeline - Row of 10 colored dots showing recent check results.
 * Reveals flapping links at a glance.
 *
 * green = live, red = removed/404/5xx, yellow = redirect/nofollow, hollow = timeout/error
 */

const statusDotColors = {
  live: 'bg-success',
  removed: 'bg-destructive',
  '404': 'bg-destructive',
  '5xx': 'bg-destructive',
  nofollow_changed: 'bg-warning',
  redirected: 'bg-warning',
  timeout: 'bg-muted-foreground/30 ring-1 ring-muted-foreground/40',
  pending: 'bg-muted-foreground/20',
};

export default function CheckTimeline({ recentChecks = [], lastChecked }) {
  // Reverse so oldest is first (left to right = oldest to newest)
  const checks = [...recentChecks].reverse().slice(-10);

  // Pad to show at least some structure
  const dots = checks.length > 0 ? checks : [];

  return (
    <div className="flex flex-col items-start gap-1">
      {dots.length > 0 ? (
        <div className="flex items-center gap-[3px]">
          {dots.map((check, i) => (
            <div
              key={i}
              className={cn(
                'w-[6px] h-[6px] rounded-full flex-shrink-0',
                statusDotColors[check.status] || 'bg-muted-foreground/20',
              )}
              title={`${check.status} — ${check.checked_at ? new Date(check.checked_at).toLocaleString() : 'unknown'}${check.response_ms ? ` (${check.response_ms}ms)` : ''}`}
            />
          ))}
        </div>
      ) : null}
      {lastChecked ? (
        <span
          className="text-[11px] text-muted-foreground cursor-default leading-tight"
          title={formatDateWithTooltip(lastChecked).absolute}
        >
          {formatRelativeDate(lastChecked)}
        </span>
      ) : (
        <span className="text-[11px] text-muted-foreground/50">Never</span>
      )}
    </div>
  );
}
